import Hotel from 'src/entities/products/hotel/Hotel';

export default class HotelFull extends Hotel {
	constructor(json: any) {
		super(json);
	}
}
